export default __webpack_public_path__ + "static/media/google.c505144a.svg";